/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { FamilyDtoName } from './familyDtoName';
import type { ChildSubCategoryDto } from './childSubCategoryDto';

export interface FamilyDto {
  /** Family code */
  code: string;
  /** Family name (multilingual) */
  name: FamilyDtoName;
  /** Sub categories associated with this family */
  subCategories?: ChildSubCategoryDto[];
}
